export enum Binary {
  True = '1',
  False = '0',
}
